import { Component, EventEmitter, HostListener, OnInit, Output, inject } from '@angular/core';
import {Router} from "@angular/router";
import {AuthService} from "../../login/auth.service";
import {RoleEnum} from "../../login/role.enum";
import {SidebarService} from "./sidebar.service";

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false
})
export class SidebarComponent implements OnInit {
  router = inject(Router);
  authService = inject(AuthService);
  sidebarService = inject(SidebarService);

  isMobile = window.innerWidth <= 991;
  @Output() menuItemClicked: EventEmitter<void> = new EventEmitter<void>();
  roleId = RoleEnum.Public;

  ngOnInit() {
    this.authService.fetchMe().then(() => {
      this.roleId = this.authService.user()!.role.id;
    });
    this.sidebarService.updateSidebarStats();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isMobile = ((event.target as Window | null)?.innerWidth ?? 0) <= 991;
  }

  navigate(path: string): void {
    void this.router.navigate([path]);
    if (this.isMobile) {
      this.menuItemClicked.emit();
    }
  }
}
